import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import RecoverPasswordPanelActions from './actions';

const initialState = Immutable({
  userId:        '',
  userEmail:     '',
  isSupportUser: false,

  avatar:     '',
  password:   '',
  repassword: '',
});

export default createReducer(on => {
  on(RecoverPasswordPanelActions.bootstrap, (state, { userId, userEmail, isSupportUser }) => {
    return state
      .set('userId', userId)
      .set('userEmail', userEmail)
      .set('isSupportUser', isSupportUser);
  });

  on(RecoverPasswordPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
